import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=6b6737b1&scoped=true&"
import script from "./AppFooter.ts?vue&type=script&lang=ts&"
export * from "./AppFooter.ts?vue&type=script&lang=ts&"
import style0 from "./AppFooter.scss?vue&type=style&index=0&id=6b6737b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6737b1",
  null
  
)

export default component.exports